import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["children", "label", "invert", "background", "className", "icon", "popoverProps", "size", "bottomSheetTitle", "tooltipOpen", "tooltipDirection"],
  _excluded2 = ["onClickOutside", "closureModes", "closureOptions", "onClose", "container", "theme", "portalClassName"],
  _excluded3 = ["onClick", "popoverProps"],
  _excluded4 = ["onClose"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef, useCallback, useRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { useFlag, useIsMobileDimension } from '@carnica/utils/hooks';
import { IconDotsRoundOutline } from '@carnica/graphics';
import { Tooltip } from "../Tooltip";
import { BottomSheet } from "../../modules/BottomSheet";
import { Text } from "../Text";
import styles from "./styles.pcss";
import { getSettings } from "./utils";
var cnAdTag = cnBem('ad-tag', styles);
var DefaultIcon = function DefaultIcon(props) {
  return /*#__PURE__*/React.createElement(IconDotsRoundOutline, _extends({}, props, {
    iconClassName: cnAdTag('dots', [props.iconClassName]),
    "data-t-id": "components-AdTag"
  }));
};
var getTheme = function getTheme(invert, theme) {
  if (typeof invert === 'boolean') {
    return invert ? 'dark' : 'light';
  }
  return theme;
};
export var AdTagStateless = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    _props$label = props.label,
    label = _props$label === void 0 ? 'реклама' : _props$label,
    invert = props.invert,
    _props$background = props.background,
    background = _props$background === void 0 ? 'light' : _props$background,
    className = props.className,
    _props$icon = props.icon,
    Icon = _props$icon === void 0 ? DefaultIcon : _props$icon,
    popoverProps = props.popoverProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'm' : _props$size,
    _props$bottomSheetTit = props.bottomSheetTitle,
    bottomSheetTitle = _props$bottomSheetTit === void 0 ? 'реклама' : _props$bottomSheetTit,
    tooltipOpen = props.tooltipOpen,
    _props$tooltipDirecti = props.tooltipDirection,
    tooltipDirection = _props$tooltipDirecti === void 0 ? 'upCenter' : _props$tooltipDirecti,
    otherProps = _objectWithoutProperties(props, _excluded);
  var buttonRef = useRef(null);
  var isMobile = useIsMobileDimension();
  var _getSettings = getSettings(size),
    iconSize = _getSettings.iconSize,
    labelSettings = _getSettings.labelSettings;
  var _ref = popoverProps || {},
    onClickOutside = _ref.onClickOutside,
    closureModes = _ref.closureModes,
    closureOptions = _ref.closureOptions,
    onClose = _ref.onClose,
    container = _ref.container,
    theme = _ref.theme,
    portalClassName = _ref.portalClassName,
    otherPopoverProps = _objectWithoutProperties(_ref, _excluded2);
  var handleBottomSheetClose = useCallback(function (e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e, 'outsideClick');
  }, [onClose]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({
    "aria-label": "\u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u0440\u0435\u043A\u043B\u0430\u043C\u0435",
    className: cnAdTag({
      size: size,
      background: background
    }, [className]),
    ref: combineRefs([ref, buttonRef]),
    type: "button"
  }, otherProps), /*#__PURE__*/React.createElement(Text, _extends({}, labelSettings, {
    className: cnAdTag('label'),
    color: "white",
    rows: 1,
    tagName: "span",
    truncate: true
  }), label), Icon && /*#__PURE__*/React.createElement(Icon, {
    className: cnAdTag('icon'),
    color: "white",
    size: iconSize
  })), isMobile ? /*#__PURE__*/React.createElement(BottomSheet, _extends({
    isOpen: tooltipOpen,
    onClose: handleBottomSheetClose,
    portalClassName: portalClassName
  }, otherPopoverProps), /*#__PURE__*/React.createElement(Text, {
    className: cnAdTag('title'),
    color: "primary",
    variant: "display-small",
    "data-t-id": "components-AdTag"
  }, bottomSheetTitle), children) : /*#__PURE__*/React.createElement(Tooltip, _extends({
    anchorRef: buttonRef,
    closureModes: closureModes,
    closureOptions: closureOptions,
    container: container,
    direction: tooltipDirection,
    invert: background === 'dark',
    isOpen: tooltipOpen,
    onClickOutside: onClickOutside,
    onClose: onClose,
    theme: getTheme(invert, theme)
  }, otherPopoverProps), children));
});
export var AdTag = /*#__PURE__*/forwardRef(function (props, ref) {
  var onClick = props.onClick,
    popoverProps = props.popoverProps,
    otherProps = _objectWithoutProperties(props, _excluded3);
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var handleClick = function handleClick(e) {
    setIsOpen.toggle();
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  var _ref2 = popoverProps || {},
    onClose = _ref2.onClose,
    otherPopoverProps = _objectWithoutProperties(_ref2, _excluded4);
  var handleClose = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onClose === null || onClose === void 0 ? void 0 : onClose.apply(void 0, args);
    setIsOpen.off();
  }, [onClose]);
  return /*#__PURE__*/React.createElement(AdTagStateless, _extends({
    onClick: handleClick,
    popoverProps: _objectSpread({
      onClose: handleClose
    }, otherPopoverProps),
    ref: ref,
    tooltipOpen: isOpen
  }, otherProps));
});